module.exports = __webpack_public_path__ + "img/18_101.3a98e438.png";